import lazyImporter from '@/utils/lazyImporter'

const userRoute = {
  component: lazyImporter('View'),
  meta: { title: 'users', icon: 'people', needsAdminRole: true },
  name: 'admin_users',
  path: '/user',
  redirect: { name: 'admin_user_list' },
  children: [
    {
      component: lazyImporter('user/UserList'),
      meta: { title: 'userList', hidden: true },
      name: 'admin_user_list',
      path: ''
    },
    {
      component: lazyImporter('user/UserUpdate'),
      meta: { title: 'userUpdate', hidden: true },
      name: 'admin_user_update',
      path: ':slug/update',
      props: true
    },
    {
      component: lazyImporter('user/UserRegister'),
      meta: { title: 'userAdd', hidden: true },
      name: 'admin_user_add',
      path: 'add'
    }
  ]
}

export default userRoute
